import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// /sel 短入口：路径直达时引导到选股页（配合 public/_redirects 的 SPA 规则）
if (window.location.pathname === '/sel' && !window.location.hash) {
  window.location.hash = '#/picker'
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
